export default [
    {
        path: '',
        component: () => import('../views/payout/list'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Ведомости выплат',
            altNavSubMenuActive: '/payout/list',
        },
        children: [
            {
                path: '/(uk/|ru/)?/payout',
                name: 'PayoutStatements',
                component: () => import('../views/payout/tables/Statements'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомости'
                },
            }, {
                path: '/(uk/|ru/)?/payout/list',
                name: 'PayoutCommon',
                component: () => import('../views/payout/tables/Common'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Транзакции'
                },
            }, {
                path: '',
                component: () => import('../views/payout/Problems'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомости выплат проблемные'
                },
                children: [{
                    path: '/(uk/|ru/)?/payout/problems',
                    name: 'PayoutStatementsProblems',
                    component: () => import('../views/payout/tables/ProblemParkDriver'),
                    query: true,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        activeSideIcon:'#icon-transaction',
                        title: 'Ведомости выплат проблемные'
                    },
                }, {
                    path: '/(uk/|ru/)?/payout/problems/ie',
                    name: 'PayoutStatementsProblemsIe',
                    component: () => import('../views/payout/tables/ProblemParkDriverIe'),
                    query: true,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        activeSideIcon:'#icon-transaction',
                        title: 'Ведомости выплат проблемные'
                    },
                }]
            }, {
                path: '/(uk/|ru/)?/payout/unpaid-orders',
                name: 'SummaryUnpaidOrders',
                component: () => import('../views/payout/tables/UnpaidOrders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: ' Сводный отчет проблемных заказов'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/payout/problems/detail',
        name: 'PayoutStatementsProblemsDetail',
        component: () => import('../views/payout/detail'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Детализация заказа'
        },
    }, {
        path: '/(uk/|ru/)?/sms-conversio/create',
        name: 'SmsCreate',
        component: () => import('../views/conversion/SmsCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Смс-конверсия',
            altNavSubMenuActive:'/sms-conversion-event/index',
        }
    }, {
        path: '/(uk/|ru/)?/sms-conversion-event/index',
        name: 'EventsList',
        component: () => import('../views/conversion/EventsList'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Смс-события',
            altNavSubMenuActive:'/sms-conversion-event/index',
        }
    }, {
        path: '/(uk/|ru/)?/sms-conversion/events/edit',
        name: 'EventEdit',
        component: () => import('../views/conversion/EventEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Смс-события'
        }
    }, {
        path: '/(uk/|ru/)?/baiga/index',
        component: () => import('../views/baiga/Index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
        },
        children: [
            {
                path: '',
                name: 'BaigaSettings',
                component: () => import('../views/baiga/Settings'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Байга'
                },
            }, {
                path: '/(uk/|ru/)?/baiga/Results',
                name: 'BaigaResults',
                component: () => import('../views/baiga/Results'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Байга'
                },
            }, {
                path: '/(uk/|ru/)?/baiga/publish',
                name: 'BaigaPublish',
                component: () => import('../views/baiga/Publish'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Байга'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/baiga/edit',
        name: 'SettingsForm',
        component: () => import('../views/baiga/SettingsForm'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Байга'
        }
    },
]
